// extracted by mini-css-extract-plugin
export default {"content":"style_content__uCWLy","none":"style_none__lehUo","btn-submit":"style_btn-submit__3NH29"};